import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import {MatChipInputEvent} from '@angular/material/chips';

@Component({
  selector: 'g10-organization-add-notifications',
  templateUrl: './add-notifications.component.html',
  styleUrls: ['./add-notifications.component.css']
})
export class AddNotificationsComponent implements OnInit {

  @Output() addNotificationValue = new EventEmitter();
  // user data
  public userData;
  // form 
  addNotificationForm: FormGroup;
  public getEmail:boolean=false;
  public getMobile:boolean=false;
  public getSpeed:boolean=false;
  public getGeofence:boolean=false;
  public notificationFor;
  public notificationType;
  public timeFrom = { hour: 0, minute: 0, meriden: 'AM', format: 12};
  public timeTo = { hour: 0, minute: 0, meriden: 'AM', format: 12};
  

  //api obj
  public vehicleObj=[];
  public manageGroupData = [];
  public filteredGroupData = [];
  public allVehicle=[];
  public allVehicleChecked:boolean=false;
/* dropdown search filter*/
  @ViewChild('search', {static: true}) searchTextBox: ElementRef;
  filteredOptions: Observable<any[]>;
  searchTextboxControl = new FormControl();
  public data=[];
/* form input chips */
  public selectable = true;
  public removable = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public mobiles=[];
  public notificationConfigData={};
  public emails=[];
  public fieldOptions={
    title:[
      {value:'overspeed',name:'Overspeed'},
     /*  {value:'geofence',name:'geofence'}, */
      {value:'halt',name:'Halt'},
      {value:'panic',name:'Panic'},
    ],
    type:[
      {value:'sms',name:'SMS'},
      {value:'call',name:'CALL'},
      {value:'email',name:'email'},
      {value:'push notifications',name:'PUSH NOTIFICATIONS'},
    ],
    vehicles:[
      {value:'619234121k2j3g41',name:'TN01CD1111'},
      {value:'6192341ask2j3g23',name:'TN02CD2222'},
      {value:'6asdfasdak2j3245',name:'TN03CD3333'},
      {value:'6agadfgafk2jvae1',name:'TN04CD4444'},
    ],
    group:[],
   /*  geofence:[
      {value:'619234121k2j3g41',name:'TN01CD1111'},
      {value:'6192341ask2j3g23',name:'TN02CD2222'},
      {value:'6asdfasdak2j3245',name:'TN03CD3333'},
      {value:'6agadfgafk2jvae1',name:'TN04CD4444'},
    ], */
  };
  public formSubmitted:boolean = false;

  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder,
    ) { 
      this.userData = this.storage.get('userInfo')
    }

  ngOnInit(): void {
    console.log(this.filteredOptions);
    console.log(this.allVehicleChecked);
    console.log(this.allVehicle.length);
    this.createNotificationForm();
    this.getVehicleList();
    this.getGroupData();
    this.getNotificationConfigData('email');
    this.getNotificationConfigData('mobile');
    /* Set filter event based on value changes */
      this.filteredOptions = this.searchTextboxControl.valueChanges
      .pipe(
        startWith<string>(''),
        map(name => this._filter(name))
      );
  }


  createNotificationForm() {
    this.addNotificationForm = this.fb.group({
     title:['',Validators.required],
     type:['',Validators.required],
     vehicles:['',Validators.required],
     timeFrom:['',Validators.required],
     timeTo:['',Validators.required],
    });
  }
/* API's vehicle data */
  getVehicleList(){
    let obj = {
      orgID: this.userData.orgID,
    }
    this.api.transportManagerVehicleList(obj).then((res:any)=>{
      if (res.status == 'success') {
      this.vehicleObj=res.data;
      this.data=res.data;
      this.searchTextboxControl.patchValue('');
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  getGroupData(){
    this.api.transportManagerManageGroupList({}).then((res:any)=>{
      if (res.status == 'success') {
      this.manageGroupData = [ ...res.data];
      this.setFilteredGroupData(res.data);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  getNotificationConfigData(dataType) {
    const obj = {
      orgID: this.userData.orgID,
      type:"list",
      notification:dataType,
    };
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationConfigData[dataType]=res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  setFilteredGroupData(data){
    if(data.length > 0){
      let filterObj = {};
      data.filter((item)=>{ 
        let keys = Object.keys(filterObj);
        if(keys.indexOf(item.type) == -1) filterObj[item.type]=[];
        let index = filterObj[item.type].indexOf(item.groupName);
        if(index == -1) filterObj[item.type].push(item.groupName);  
      });
      setTimeout(()=>{
        let objKeys = Object.keys(filterObj);
        objKeys.filter((key)=>{
          filterObj[key].filter((val)=>{
            let result = { name:val,type:key};
            this.filteredGroupData.push(result);
            this.fieldOptions['group'].push(result);
          })
        });
        console.log(this.filteredGroupData);
      },200);
    }
  }

/* Used to filter data based on search input */
  private _filter(name: string): String[] {
  const filterValue = name.toLowerCase();
  const filteredList = this.data.filter(option => option.vehRegNo.toLowerCase().indexOf(filterValue) === 0);
  return filteredList;
  }

/* Remove from selected values based on uncheck */
  selectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
    const index = this.addNotificationForm.controls.vehicles.value.indexOf(event.source.value);
    this.addNotificationForm.controls.vehicles.value.splice(index, 1);
   /*  const selectedIndex= this.allVehicle.indexOf(event.source.value);
    this.allVehicle.splice(selectedIndex,1);
    this.allVehicleChecked=false; */
    }
   /*  console.log(event);
    this.allVehicleChecked = this.allVehicle != null && this.allVehicle.length==this.data.length; */
  }

  openedChange(e) {
  // Set search textbox value as empty while opening selectbox
  this.searchTextboxControl.patchValue('');
  // Focus to search textbox while clicking on selectbox
  if (e == true) {
    this.searchTextBox.nativeElement.focus();
    console.log(this.searchTextBox);
  }
  }

/* Clearing search textbox value */
  clearSearch(event) {
  event.stopPropagation();
  this.searchTextboxControl.patchValue('');
  }
/* All select */
toggleAllSelection(e){
  if(this.allVehicle.length>0)  {
    this.allVehicle=[];
  }
  else {
    this.allVehicle=[];
    this.vehicleObj.filter((e)=>this.allVehicle.push(e.vehicleID));
  }
  this.addNotificationForm.controls.vehicles.patchValue(this.allVehicle);
  this.allVehicleChecked = this.allVehicle != null && this.allVehicle.length==this.data.length;
}
checkAllSelected(){
  if (this.allVehicle == null) {
    return false;
  }
  return this.allVehicle.length > 0 && !this.allVehicleChecked;
}

  fieldChange(e,type,field){
    if(type=='dropdown'){
      this.addNotificationForm.controls[field].patchValue(e.value);
      if(field=='type'){
        if(e.value && e.value.length > 0){
          this.addNotificationForm.addControl('group',this.fb.control('',[Validators.required]));
          if(e.value.includes('email')){
            this.getEmail=true;
          }
          else{
            if(this.getEmail)
            {
              let value = this.addNotificationForm.value['group'];
              let finalValue = [ ...value];
              this.fieldOptions['group'].filter((item)=>{ 
                if(item.type=='email'){
                  let index = value.indexOf(item.name);
                  if(index != -1) delete finalValue[index];
                }
              });
              let result = finalValue.filter((e)=> { if(e) return e;});
              this.addNotificationForm.controls['group'].patchValue(result);
              console.log(this.addNotificationForm.value,result,finalValue);
              this.getEmail=false;
            }
          }
          if(e.value.includes('sms')||e.value.includes('call')||e.value.includes('push notifications')){
            this.getMobile=true;
          }
          else{
            if(this.getMobile)
            {
              let value = this.addNotificationForm.value['group'];
              let finalValue = [ ...value];
              this.fieldOptions['group'].filter((item)=>{ 
                if(item.type=='mobile'){
                  let index = value.indexOf(item.name);
                  if(index != -1) delete finalValue[index];
                }
              });
              let result = finalValue.filter((e)=> { if(e) return e; });
              this.addNotificationForm.controls['group'].patchValue(result);
              console.log(this.addNotificationForm.value,result,finalValue);
              this.getMobile=false;
            }
          }
        }
        else{
          this.addNotificationForm.removeControl('group');
          this.getEmail = false;
          this.getMobile = false;
        }

      }
      if(field=='title'){
        this.notificationFor=e.value;
        if(e.value=='overspeed'){
          //if(this.getGeofence) this.addNotificationForm.removeControl('geofence');
          // this.geofenceFormControl.reset();
         /*  this.addNotificationForm.addControl('speedAbove',this.fb.control('',[Validators.required]));
          this.addNotificationForm.addControl('speedTill',this.fb.control('',[Validators.required])); */
          this.addNotificationForm.addControl('speedLimit',this.fb.control('',[Validators.required,Validators.max(200)]));
          this.getGeofence=false;
          this.getSpeed=true;
        }
       /*  else if(e.value=='geofence'){
          if(this.getSpeed){
            // this.addNotificationForm.removeControl('speedAbove');
            // this.addNotificationForm.removeControl('speedTill');
            this.addNotificationForm.removeControl('speedLimit');
          }
          this.getSpeed=false;
          // this.speedAboveFormControl.reset();
          // this.speedTillFormControl.reset();
          this.addNotificationForm.addControl('geofence',this.fb.control('',[Validators.required]));
          this.getGeofence=true;
        } */
        else{
          if(this.getSpeed || this.getGeofence){
            this.addNotificationForm.removeControl('speedLimit');
            //this.addNotificationForm.removeControl('geofence');
            this.addNotificationForm.removeControl('speedAbove');
            this.addNotificationForm.removeControl('speedTill');
          }
          this.getGeofence=false;
          this.getSpeed=false;
         /*  this.geofenceFormControl.reset();
          this.speedAboveFormControl.reset();
          this.speedTillFormControl.reset(); */
        }
      }
      if(field=='group'){
        this.addNotificationForm.controls.group.patchValue(e.value);
        console.log(this.addNotificationForm.controls.group.value);
        if(this.formSubmitted) this.groupValidation();
      }
      if (field=='mobile'){
        this.mobiles=e.value;
        this.addNotificationForm.controls.mobile.patchValue(e.value);       
      }
      if (field=='email'){
        this.emails=e.value;
        this.addNotificationForm.controls.email.patchValue(e.value);
      }
    }
  }
/* Time Change Event*/
  onChangeHour(event,field) {
    let timevalue=`${event.hour}:${event.minute} ${event.meriden}`
    this.addNotificationForm.controls[field].patchValue(timevalue);
    if(Number(event.minute)<10) event.minute=event.minute.substring(1);
    if(field=='timeFrom') this.timeFrom = event;
    if(field=='timeTo') this.timeTo = event;
  }
/* chip add and remove */
add(event: MatChipInputEvent,field): void {

  const value = (event.input.value || '').trim();
  // Add our fruit
  if (value) {
    if (field=='mobileField') this.mobiles.push(value);
    if (field=='emailField') this.emails.push(value);
  }
  if (field=='mobileField') this.addNotificationForm.controls.mobile.patchValue(this.mobiles);
  if (field=='emailField') this.addNotificationForm.controls.email.patchValue(this.emails);
  // Clear the input value
  if (event.input) {
    event.input.value = '';
  };
}

remove(value,field): void {
  let index;
  if (field=='mobileField') {
    index = this.mobiles.indexOf(value);
    if (index >= 0) this.mobiles.splice(index, 1);
  }
  if (field=='emailField') {
    index = this.emails.indexOf(value);
    console.log(index,value);
    if (index >= 0) this.emails.splice(index, 1);
    console.log(this.emails);
  }
  if (field=='mobileField') this.addNotificationForm.controls.mobile.patchValue(this.mobiles);
  if (field=='emailField') this.addNotificationForm.controls.email.patchValue(this.emails);
}

/* Get Email Id from given notificationID*/

getEmailID(ID){
  let result=[];
  this.notificationConfigData['email'].filter((element)=>{
    if (element['notificationID']==ID) result.push(element);
  });
  if (result && result.length>0 ) return result[0].name;
  else return '---';
}

/* Get Mobile Number from given notificationID*/

getMobileNo(ID){
  let result=[];
  this.notificationConfigData['mobile'].filter((element)=>{
    if (element['notificationID']==ID) result.push(element);
  });
  if (result && result.length>0 ) return result[0].name;
  else return '---';
}

groupValidation(){
  let type = this.addNotificationForm.value['type'];

  if(type.indexOf('email')){

    let foundEmail = false;
    this.addNotificationForm.value.group.filter((val)=>{
      this.fieldOptions.group.filter((item)=>{
        if(item.type == 'email'){
          if(item.name == val) foundEmail = true;
        }
      })
    });
    if(!foundEmail) this.addNotificationForm.controls.group.setErrors({invalidEmail:true});
    else this.addNotificationForm.controls.group.setErrors({invalidEmail:null});

  }
  if(type.includes('sms')|| type.includes('call')|| type.includes('push notifications')){
    let foundMobile = false;
    this.addNotificationForm.value.group.filter((val)=>{
      this.fieldOptions.group.filter((item)=>{
        if(item.type == 'mobile'){
          if(item.name == val) foundMobile = true;
        }
      })
    });
    if(!foundMobile) this.addNotificationForm.controls.group.setErrors({invalidMobile:true});
    else this.addNotificationForm.controls.group.setErrors({invalidMobile:null});
  }

}

/* Submit */
  onSubmit(){
    //this.groupValidation();
    //this.formSubmitted = true;
    if(this.addNotificationForm.valid){
      let obj={
        ...this.addNotificationForm.value
      };
      if (this.allVehicleChecked) obj['vehicles']=["all"];
      this.addNotificationValue.emit(obj);
    }
  }

}
